const state = {
  jobs: {}
}

export default state


